import { render, staticRenderFns } from "./FloatingComponents.vue?vue&type=template&id=38a3887c&"
import script from "./FloatingComponents.vue?vue&type=script&lang=js&"
export * from "./FloatingComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports